import { Outlet, Route, Routes } from "react-router-dom";
import AssociatesComponent from "./associates/AssociatesComponent";
import SignUp from "./account/SignUp";
import SignIn from "./account/SignIn";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoute";
import CreateAssociate from "./associates/CreateAssociate";
import VehiclesComponent from "./vehicles/VehiclesComponent";
import CreateVehicle from "./vehicles/CreateVehicle";
import VehicleDetail from "./vehicles/VehicleDetail";
import Settings from "./settings/Settings";
import Landing from "./landing/Landing";
import LandingLayout from "./LandingLayout";
import DashboardComponent from "./dashboard/DashboardComponent";
import IdentityComponent from "./identity/IdentityComponent";
import VehiclesTable from "./vehicles/vehicle-table/VehiclesTable";
import AssociatesTable from "./associates/table/AssociatesTable";
import ApprovalVehiclesComponent from "./vehicles/vehicle-approval/ApprovalVehiclesComponent";
import ApprovalHistoryComponent from "./vehicles/vehicle-approval/ApprovalHistoryComponent";
import { Suspense } from "react";
import NotFound from "./error/NotFound";
import AccountComponent from "./account/AccountComponent";
import DeactivatedComponent from "./deactivated/DeactivatedComponent";
import ActiveOrganizationRoute from "./ActiveOrganizationRoute";
import AuthorizationComponent from "./authorization/AuthorizationComponent";
import AuthorizationRoute from "./AuthorizationRoute";
import AssociateGroupsTable from "./associates/groups/table/AssociateGroupsTable";
import CreateAssociateGroup from "./associates/groups/CreateAssociateGroup";
import Licenses from "./licenses/Licenses";
import ReportsTable from "./reports/table/ReportsTable";
import ReportsComponent from "./reports/table/ReportsComponent";
import ReportDetail from "./reports/detail/ReportDetail";
import VehicleGroupsTable from "./vehicles/vehicle-groups/table/VehicleGroupsTable";
import CreateVehicleGroup from "./vehicles/vehicle-groups/CreateVehicleGroup";

const Routing = () => {
  return (
    <Routes>
      <Route>
        <Route
          element={
            <Suspense fallback={<></>}>
              <LandingLayout />
            </Suspense>
          }
        >
          <Route index element={<Landing />} />
        </Route>
        <Route path="login" element={<SignIn />} />
        <Route
          element={
            <Suspense fallback={<></>}>
              <Layout />
            </Suspense>
          }
        >
          <Route path="register" element={<SignUp />} />
          <Route path="licenses" element={<Licenses />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AuthorizationRoute />}>
              <Route element={<ActiveOrganizationRoute />}>
                <Route element={<Outlet />}>
                  <Route path="dashboard" element={<DashboardComponent />} />
                  <Route path="associates" element={<AssociatesComponent />}>
                    <Route index element={<AssociatesTable />} />
                    <Route path="create" element={<CreateAssociate />} />
                    <Route path="groups">
                      <Route index element={<AssociateGroupsTable />} />
                      <Route path="create" element={<CreateAssociateGroup />} />
                    </Route>
                  </Route>
                  <Route path="vehicles" element={<VehiclesComponent />}>
                    <Route index element={<VehiclesTable />} />
                    <Route
                      path="detail/:vehicleId"
                      element={<VehicleDetail />}
                    />
                    <Route path="create" element={<CreateVehicle />} />
                    <Route path="groups">
                      <Route index element={<VehicleGroupsTable />} />
                      <Route path="create" element={<CreateVehicleGroup />} />
                    </Route>
                    <Route path="approvals">
                      <Route index element={<ApprovalVehiclesComponent />} />
                      <Route
                        path="history"
                        element={<ApprovalHistoryComponent />}
                      />
                    </Route>
                  </Route>
                  <Route path="organization-settings" element={<Settings />} />
                  <Route path="reports" element={<ReportsComponent />}>
                    <Route index element={<ReportsTable />} />
                    <Route path="detail/:reportId" element={<ReportDetail />} />
                  </Route>
                </Route>
              </Route>
              <Route path="account" element={<AccountComponent />} />
              <Route path="identity" element={<IdentityComponent />} />
              <Route path="deactivated" element={<DeactivatedComponent />} />
            </Route>
            <Route path="authorization" element={<AuthorizationComponent />} />
          </Route>
        </Route>
        <Route
          path="*"
          element={
            <Suspense fallback={<></>}>
              <NotFound />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default Routing;
